import { createEnv } from '@t3-oss/env-nextjs';
import { z } from 'zod';

// Helper function to get the dashboard URL based on environment
function getDashboardUrl(): string {
  // If explicitly set, use it (for production and local dev)
  if (process.env.NEXT_PUBLIC_DASHBOARD_URL) {
    return process.env.NEXT_PUBLIC_DASHBOARD_URL;
  }

  // For Vercel preview deployments, use NEXT_PUBLIC_VERCEL_URL (auto-exposed)
  if (process.env.NEXT_PUBLIC_VERCEL_URL) {
    return `https://${process.env.NEXT_PUBLIC_VERCEL_URL}`;
  }

  throw new Error('NEXT_PUBLIC_DASHBOARD_URL or NEXT_PUBLIC_VERCEL_URL must be set');
}

export const keys = () =>
  createEnv({
    client: {
      NEXT_PUBLIC_DASHBOARD_URL: z.string().min(1).url(),
      NEXT_PUBLIC_MARKETING_URL: z.string().min(1).url(),
      // It's likely that you don't want to develop a public API when starting out.
      // The URL is optional, to ease deployment in case it's missing.
      NEXT_PUBLIC_PUBLIC_API_URL: z.string().optional().default('#')
    },
    runtimeEnv: {
      NEXT_PUBLIC_DASHBOARD_URL: getDashboardUrl(),
      NEXT_PUBLIC_MARKETING_URL: process.env.NEXT_PUBLIC_MARKETING_URL,
      NEXT_PUBLIC_PUBLIC_API_URL: process.env.NEXT_PUBLIC_PUBLIC_API_URL
    }
  });
